import { createFileRoute } from "@tanstack/react-router";
import { EditRoles } from "../../app/views/competence/editRoles";

export const Route = createFileRoute("/competence/editRoles")({
  component: EditRoles,
});
